var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    color: "orange",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Top Line",
    x1: 10,
    y1: 20,
    x2: 90,
    y2: 20,
    stroke: "currentColor",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    id: "J Line",
    x1: 35,
    y1: 20,
    x2: 35,
    y2: 62,
    stroke: "currentColor",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "J Curve",
    d: "M35,61 A5,5 0 0,1 15,61",
    stroke: "currentColor",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    id: "T Line",
    x1: 65,
    y1: 20,
    x2: 65,
    y2: 75,
    stroke: "currentColor",
    strokeWidth: 10
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5dfce9c0f13fdb73a7422918b3cad0a1.svg";
export { ForwardRef as ReactComponent };